import makeTheme from "./default";
import { createMuiTheme } from "@material-ui/core";

const DARK_THEME = {
  // Primary
  primary: "#27E8EF",
  primaryLight: "#333058",
  primaryGradient: `linear-gradient(45deg, #27E8EF 30%, #2E2794 90%)`,
  primaryContrast: "#777780",  
  // Secondary
  secondary: "#2c2952",
  secondaryLight: "#3c3957",
  secondaryContrast: "#EEEEFF",
  
  // Hover
  hoverSecondary: "#C2BFE5",
  hoverSecondaryContrast: "#111133",
  hoverLight: "#57547a",
  // Border
  borderColor: "#373367",
  darkOnlyBorder: "#373367",

  lightenRate: 2,
  darkenRate: 2,
  // Text
  textPrimary: "#eeeeff",
  textSecondary: "#C2BFE5",
  textError:"#eeeeff",
  // Selected Item
  selected: "#3c3957",
  // Background
  background: "#211F3B",
  backgroundDark: "#151A3A",
  dropdown: "#282C4D",
  search: "#23233F",
  backgroundLight: "#333058",
  action: "#423f6e",
  change:"#27E8EF",
  // Feedback states
  warning: "#FFC260",
  success: "#529e80",
  info: "#9013FE",
  error: "#b33756",
  // Shadows
  rowHoverShadow:
    "0px 0px 10px -2px rgba(0,0,0,0.2), 0px 3px 13px 0px rgba(0,0,0,0.14), 0px 1px 15px 0px rgba(0,0,0,0.12)",
  elevation2:
    "0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)",
  elevation3:
    "0px 0px 10px -2px rgba(0,0,0,0.2), 0px 3px 13px 0px rgba(0,0,0,0.14), 0px 1px 15px 0px rgba(0,0,0,0.12)",
  elevation6:
    "0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)",
  darkOnlyElevation2:
    "0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)",
  darkOnlyElevation3:
    "0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)",
  lightOnlyElevation2: "none",
};

const LIGHT_THEME = {
  // Primary
  primary: "#ac6cd9",
  primaryLight: "#ac6cd9",
  primaryGradient: `linear-gradient(45deg, #ac6cd9 30%, #dfcced 90%)`,
  primaryContrast: "#777780",  
  // Secondary
  secondary: "#ac6cd9",
  secondaryLight: "#FFFFFF",
  secondaryContrast: "#FFFFFF",
  // Hover
  hoverSecondary: "#c396e3",
  hoverSecondaryContrast: "#FFFFFF",
  hoverLight: "#dfcced",
  // Border
  borderColor: "#ae86d9",
  darkOnlyBorder: "transparent",
  // Text
  textPrimary: "#111111",
  textError:"#eeeeff",
 
 // textPrimaryo: "#ffffff",
  textSecondary: "#444466",
  // Selected Item
  selected: "#ede1f5",

  // Backgrounds
  background: "#F7F7fF",
  backgroundDark: "#FFFFFF",
  dropdown: "#FFFFFF",
  search: "#FFFFFF",
  backgroundLight: "#FFFFFF",
  action: "#ac6cd9",
   change:"#D86CD9",
 // change :"#D96C83",


  lightenRate: -2,
  darkenRate: -7,
  // Feedback states
  warning: "#FFC260",
  success: "#529e80",
  info: "#9013FE",

  error: "#b33756",
 
  // Shadows
  rowHoverShadow:
    "-3px 3px 15px -2px #00000011, -2px 5px 19px 0px #00000022, 0px 1px 17px 0px #00000022",
  elevation2:
    "-1.5px 1.5px 4px -2px #ac6cd911, -2px 2px 5px 0px #ac6cd922, 0px 0px 6px 0px #ac6cd922",
  elevation3:
    "-3px 3px 15px -2px #ac6cd911, -2px 5px 19px 0px #ac6cd922, 0px 1px 17px 0px #ac6cd922",
  elevation6:
    "-3px 3px 17px -2px #ac6cd922, -2px 5px 21px 0px #ac6cd933, 0px 1px 19px 0px #ac6cd933",
  darkOnlyElevation2: "none",
  darkOnlyElevation3: "none",
  lightOnlyElevation2:
    "-1.5px 1.5px 4px -2px #ac6cd911, -2px 2px 5px 0px #ac6cd922, 0px 0px 6px 0px #ac6cd922",
};

const BLACK_THEME = {
  // Primary
  primary: "#5574ff",
  primaryLight: "#DF3458",
  primaryGradient: `linear-gradient(45deg, #5574ff 30%, #2E2794 90%)`,
  primaryContrast: "#777780", 

  // Secondary
  secondary: "#282830",
  secondaryLight: "#FFFFFF11",
  secondaryContrast: "#EEEEFF",
  // Hover
  hoverSecondary: "#C2BFE5",
  hoverSecondaryContrast: "#111133",
  hoverLight: "#57547a",
  // Border
  borderColor: "#eeeeee11",
  darkOnlyBorder: "#373367",

  lightenRate: 2,
  darkenRate: 2,
  // Text
  textPrimary: "#eeeeff",
  textSecondary: "#cccccc",
  textError:"#eeeeff",
  // Selected Item
  selected: "#000000",
  // Background
  background: "#171717",
  backgroundDark: "#1c1c21",
  dropdown: "#2F2F39",
  search: "#1c1c21",
  backgroundLight: "#2F2F39",
  action: "#5574ff",
  change:"#88A7FF",
 // change:"#002BEE",
  // Feedback states
  warning: "#FFC260",
  success: "#529e80",
  info: "#9013FE",
  error: "#b33756",
  // Shadows
  rowHoverShadow:
    "0px 0px 10px -2px rgba(0,0,0,0.2), 0px 3px 13px 0px rgba(0,0,0,0.14), 0px 1px 15px 0px rgba(0,0,0,0.12)",
  elevation2:
    "0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)",
  elevation3:
    "0px 0px 10px -2px rgba(0,0,0,0.2), 0px 3px 13px 0px rgba(0,0,0,0.14), 0px 1px 15px 0px rgba(0,0,0,0.12)",
  elevation6:
    "0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)",
  darkOnlyElevation2:
    "0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)",
  darkOnlyElevation3:
    "0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)",
  lightOnlyElevation2: "none",
};

const light = createMuiTheme(makeTheme(LIGHT_THEME));
const dark = createMuiTheme(makeTheme(DARK_THEME));
const black = createMuiTheme(makeTheme(BLACK_THEME));

const themes = {
  light,
  dark,
  black
};

export default function getTheme(theme) {
  return themes[theme];
}

// const LIGHT_THEME = {
//   // Primary color
//   primary: "#54c6ff",
//   primaryLight: "#FFFFFF",
//   primaryContrast: "#EEEEFF",  
//   primaryGradient: `linear-gradient(45deg, #27E8EF 30%, #54c6ff 90%)`,
//   // Secondary color
//   secondary: "#54c6ff",
//   secondaryLight: "#cfeeff",
//   secondaryContrast: "#FFFFFF",
//   secondaryHover: "#ccccdd",
//   // Hover colors
//   hoverPrimary: "#6ecfff",
//   hoverPrimaryContrast: "#FFFFFF",

//   textHover: "#333444",
//   // Border
//   borderColor: "#2694c9",

//   textPrimary: "#111111",
//   contrastText: "#ffffff",
//   contrastHover: "#ff0000",
//   textLight: "#333333",
//   textSecondary: "#444466",
//   selectedItem: "#33B5E522",
//   // Website backgrounds
//   background: "#F7F7fF",
//   lightenRate: -2,
//   darkenRate: -7,
//   // Feedback states
//   warning: "#fcda88",
//   success: "#72edbc",
//   info: "#bae1ff",
//   error: "#ff9497",
//   // Shadows
//   elevation2:
//     "-1.5px 1.5px 4px -2px #5eefff11, -2px 2px 5px 0px #5eefff22, 0px 0px 6px 0px #5eefff22",
//   elevation3:
//     "-3px 3px 15px -2px #5eefff11, -2px 5px 19px 0px #5eefff22, 0px 1px 17px 0px #5eefff22",
//   elevation6:
//     "-3px 3px 17px -2px #5eefff22, -2px 5px 21px 0px #5eefff33, 0px 1px 19px 0px #5eefff33",
//   darkOnlyElevation2: "none",
//   darkOnlyElevation3: "none",
// };
